import styled from "@emotion/native";
import Text from "../Text";

export const Container = styled.View({});

export const Prefix = styled(Text)({
	marginTop: 26,
	marginHorizontal: 20,
	textAlign: "center",
});

export const Summary = styled(Text)({
	marginTop: 7,
	marginBottom: 13,
	paddingHorizontal: 10,
	textAlign: "center",
});
